<p-accordion styleClass="cfc-collapse-container">
  <p-accordionTab [(selected)]="!collapse">
    <div class="cfc-conditional-container mb-20">
      <ng-container *ngIf="conditionsTemplate">
        <ng-container
          *ngTemplateOutlet="conditionsTemplate; context: { $implicit: form }"
        ></ng-container>
      </ng-container>
      <ng-container *ngIf="advanced; else defaultAdvancedArea">
        <div class="mb-10">
          <button
            class="cfc-advanced-toggle-button"
            [ngClass]="{ active: !advancedCollapsed }"
            (click)="onAdvancedToggleBtnClick()"
          >
            {{ "Library.UI.SearchForm.AdvancedSearch" | translate
            }}<i class="pi pi-triangle-under"></i>
          </button>
        </div>
        <p-accordion styleClass="cfc-collapse-container">
          <p-accordionTab [(selected)]="!advancedCollapsed">
            <ng-container *ngIf="advancedTemplate">
              <ng-container
                *ngTemplateOutlet="
                  advancedTemplate;
                  context: { $implicit: form }
                "
              ></ng-container>
            </ng-container>
          </p-accordionTab>
        </p-accordion>
      </ng-container>
      <ng-template #defaultAdvancedArea>
        <ng-container *ngIf="advancedTemplate">
          <ng-container
            *ngTemplateOutlet="advancedTemplate; context: { $implicit: form }"
          ></ng-container>
        </ng-container>
      </ng-template>
      <div class="p-text-center">
        <ng-container *ngIf="buttonsTemplate">
          <ng-container *ngTemplateOutlet="buttonsTemplate"></ng-container>
        </ng-container>
        <button
          pButton
          type="button"
          label="{{ 'Library.UI.SearchForm.Search' | translate }}"
          class="p-content-button mr-10"
          (click)="onSearchBtnClick($event)"
        ></button>
        <button
          pButton
          type="button"
          label="{{ 'Library.UI.SearchForm.Clear' | translate }}"
          class="p-button-secondary p-content-button"
          (click)="onResetBtnClick($event)"
        ></button>
      </div>
    </div>
  </p-accordionTab>
</p-accordion>
<div class="cfc-collapse-toggle-container mb-20" *ngIf="showCollapseWidget">
  <hr class="cfc-divider" />
  <button
    pButton
    label="{{
      (collapse
        ? 'Library.UI.SearchForm.Expand'
        : 'Library.UI.SearchForm.Collapse'
      ) | translate
    }}"
    type="button"
    [icon]="collapse ? 'pi pi-arrow-down-gold' : 'pi pi-arrow-up-gold'"
    iconPos="right"
    class="p-button-outlined cfc-collapse-button mh-10"
    (click)="onToggleBtnClick()"
  ></button>
  <hr class="cfc-divider" />
</div>
